import * as Sentry from '@sentry/react';
import { AxiosResponse } from 'axios';

import { APResponse, RequestOptions } from '@qality/common-model/src/AP/AP';
import { PromiseService } from '@qality/common-service';

export default {
  request: (
    url: string | RequestOptions,
    options?: RequestOptions
  ): Promise<AxiosResponse | APResponse> => {
    addBreadcrumb(url);
    return PromiseService.retry(() => window.AP.request(url, options));
  },

  noRetry: (
    url: string | RequestOptions,
    options?: RequestOptions
  ): Promise<APResponse> => {
    addBreadcrumb(url);
    return window.AP.request(url, options);
  },
};

function addBreadcrumb(url: string | RequestOptions): void {
  Sentry.addBreadcrumb({
    category: 'xhr',
    message: 'Request made to: ' + JSON.stringify(url),
    level: 'info',
  });
}
